import { defineMessages } from 'react-intl';

const pretailoringPageMessages = defineMessages({
  title: {
    id: 'pretailoring.page.title',
    defaultMessage: 'Tailoring Questions',
    description: 'Pretailoring page title',
  },
  lifeCycleSortBy: {
    id: 'pretailoring.page.lifeCycleSortBy',
    defaultMessage: 'Sort By:',
    description: 'Pretailoring page lifecycle sort by',
  },
  lifecycleNavTitle: {
    id: 'pretailoring.page.lifecycleNavTitle',
    defaultMessage: 'Lifecycle Process Navigator',
    description: 'Pretailoring page lifecycle nav title',
  },
  lifecycleIncludedTitle: {
    id: 'pretailoring.page.lifecycleIncludedTitle',
    defaultMessage: 'Relevant Building Blocks ({count})',
    description: 'Pretailoring page lifecycle included title',
  },
  lifecycleExcludedTitle: {
    id: 'pretailoring.page.lifecycleExcludedTitle',
    defaultMessage: 'Irrelevant Building Blocks ({count})',
    description: 'Pretailoring page lifecycle excluded title',
  },
  lifecycleDOSortIncludedTitle: {
    id: 'pretailoring.page.lifecycleDOSortIncludedTitle',
    defaultMessage: 'Included Design Obligations ({count})',
    description: 'Pretailoring page lifecycle do sort title',
  },
  lifecycleMTSSortIncludedTitle: {
    id: 'pretailoring.page.lifecycleMTSSortIncludedTitle',
    defaultMessage: 'Included Maturity Stages ({count})',
    description: 'Pretailoring page lifecycle mts sort title',
  },
  lifecycleDOSortExcludedTitle: {
    id: 'pretailoring.page.lifecycleDOSortExcludedTitle',
    defaultMessage: 'Excluded Design Obligations ({count})',
    description: 'Pretailoring page lifecycle do sort excluded title',
  },
  lifecycleMTSSortExcludedTitle: {
    id: 'pretailoring.page.lifecycleMTSSortExcludedTitle',
    defaultMessage: 'Excluded Maturity Stages ({count})',
    description: 'Pretailoring page lifecycle mts sort excluded title',
  },
  lifecycleCheckDetails: {
    id: 'pretailoring.page.lifecycleCheckDetails',
    defaultMessage: 'See more details',
    description: 'Pretailoring page lifecycle check details',
  },
  productInfoButton: {
    id: 'pretailoring.page.productInfoButton',
    defaultMessage: 'Show product info',
    description: 'Pretailoring page product info button',
  },

  productSaveButton: {
    id: 'pretailoring.page.saveButton',
    defaultMessage: 'Save',
    description: 'Pretailoring page save button',
  },
  dialogCancelTitle: {
    id: 'pretailoring.page.dialogCancelTitle',
    defaultMessage: 'Cancel product creation',
    description: 'Pretailoring page dialog cancel title',
  },
  dialogCancelText: {
    id: 'pretailoring.page.dialogCancelText',
    defaultMessage: 'Your changes will not be saved. Are you sure you want to cancel product creation?',
    description: 'Pretailoring page dialog cancel text',
  },
  dialogCancelConfirmButton: {
    id: 'pretailoring.page.dialogCancelConfirmButton',
    defaultMessage: 'Cancel',
    description: 'Pretailoring page dialog cancel confirm button',
  },
  updatedAt: {
    id: 'pretailoring.page.updatedAt',
    defaultMessage: 'Saved on {date} at {time}',
    description: 'Pretailoring page updated at label',
  },

  noBuildingBlocks: {
    id: 'pretailoring.page.noBuildingBlocks',
    defaultMessage: 'No Building Blocks.',
    description: 'Pretailoring page no building blocks label',
  },

  buildingBlockCardManualyIncluded: {
    id: 'pretailoring.page.buildingBlockCardManualyIncluded',
    defaultMessage: 'This Building Block was included manually.',
    description: 'Pretailoring page building block card manually included',
  },
  buildingBlockCardManualyExcluded: {
    id: 'pretailoring.page.buildingBlockCardManualyExcluded',
    defaultMessage: 'This Building Block was excluded manually.',
    description: 'Pretailoring page building block card manually excluded',
  },

  singleBuildingBlockModalTitle: {
    id: 'pretailoring.page.singleBuildingBlockModalTitle',
    defaultMessage: 'Building Block: {name}',
    description: 'Pretailoring page single building block modal title',
  },

  singleBuildingBlockTabGeneralDetails: {
    id: 'pretailoring.page.singleBuildingBlockTabGeneralDetails',
    defaultMessage: 'General details',
    description: 'Pretailoring page single building block tab general details',
  },
  singleBuildingBlockTabDesignObligation: {
    id: 'pretailoring.page.singleBuildingBlockTabDesignObligation',
    defaultMessage: 'Design Obligation',
    description: 'Pretailoring page single building block tab design obligation',
  },
  singleBuildingBlockTabDataBlocks: {
    id: 'pretailoring.page.singleBuildingBlockTabDataBlocks',
    defaultMessage: 'Data Blocks',
    description: 'Pretailoring page single building block tab data blocks',
  },
  singleBuildingBlockTabInformation: {
    id: 'pretailoring.page.singleBuildingBlockTabInformation',
    defaultMessage: 'Information',
    description: 'Pretailoring page single building block tab information',
  },
  singleBuildingBlockTabNoInformation: {
    id: 'pretailoring.page.singleBuildingBlockTabNoInformation',
    defaultMessage: 'No information available for this building block.',
    description: 'Pretailoring page single building block tab no information',
  },

  singleBuildingBlockDesignObligation: {
    id: 'pretailoring.page.singleBuildingBlockDesignObligation',
    defaultMessage: 'Design Obligation:',
    description: 'Pretailoring page single building block design obligation',
  },
  singleBuildingBlockDesignObligationDescription: {
    id: 'pretailoring.page.singleBuildingBlockDesignObligationDescription',
    defaultMessage: 'Design Obligation description:',
    description: 'Pretailoring page single building block design obligation description',
  },
  singleBuildingBlockMaturityStages: {
    id: 'pretailoring.page.singleBuildingBlockMaturityStages',
    defaultMessage: 'Maturity Stages:',
    description: 'Pretailoring page single building block maturity stages',
  },
  singleBuildingBlockApplicableFor: {
    id: 'pretailoring.page.singleBuildingBlockApplicableFor',
    defaultMessage: 'Applicable for:',
    description: 'Pretailoring page single building block applicable for',
  },
  singleBuidlingBlockInclusionExplanation: {
    id: 'pretailoring.page.singleBuidlingBlockInclusionExplanation',
    defaultMessage: 'Inclusion Explanation:',
    description: 'Pretailoring page single building block inclusion explanation',
  },
  singleBuildingBlockFullCaption: {
    id: 'pretailoring.page.singleBuildingBlockFullCaption',
    defaultMessage: 'Full caption:',
    description: 'Pretailoring page single building block full caption',
  },
  singleBuildingBlockTargetState: {
    id: 'pretailoring.page.singleBuildingBlockTargetState',
    defaultMessage: 'Target state:',
    description: 'Pretailoring page single building block target state',
  },
  singleBuildingBlockWhy: {
    id: 'pretailoring.page.singleBuildingBlockWhy',
    defaultMessage: 'Why:',
    description: 'Pretailoring page single building block why',
  },
  singleBuildingBlockConsequencesOfNoResponse: {
    id: 'pretailoring.page.singleBuildingBlockConsequencesOfNoResponse',
    defaultMessage: 'Consequences of no response:',
    description: 'Pretailoring page single building block consequences of no response',
  },
  singleBuildingBlockDefinitionOfDone: {
    id: 'pretailoring.page.singleBuildingBlockDefinitionOfDone',
    defaultMessage: 'Definition of Done:',
    description: 'Pretailoring page single building block definition of done',
  },
  singleBuildingBlockPreconditionAssumptions: {
    id: 'pretailoring.page.singleBuildingBlockPreconditionAssumptions',
    defaultMessage: 'Precondition / assumptions:',
    description: 'Pretailoring page single building block precondition assumptions',
  },
  singleBuildingBlockBuTemplate: {
    id: 'pretailoring.page.singleBuildingBlockBuTemplate',
    defaultMessage: 'BU Template:',
    description: 'Pretailoring page single building block bu template',
  },
  singleBuildingBlockGeneralTemplate: {
    id: 'pretailoring.page.singleBuildingBlockGeneralTemplate',
    defaultMessage: 'General Template:',
    description: 'Pretailoring page single building block general template',
  },

  singleBuildingBlockInformation: {
    id: 'pretailoring.page.singleBuildingBlockInformation',
    defaultMessage: 'Information:',
    description: 'Pretailoring page single building block information',
  },

  singleBuildingBlockDataBlocks: {
    id: 'pretailoring.page.singleBuildingBlockDataBlocks',
    defaultMessage: 'Data Blocks:',
    description: 'Pretailoring page single building block data blocks',
  },
  singleBuildingBlockDataBlockDescription: {
    id: 'pretailoring.page.singleBuildingBlockDataBlockDescription',
    defaultMessage: 'Description:',
    description: 'Pretailoring page single building block data block description',
  },
  singleBuildingBlockDataBlockDefinitionOfDone: {
    id: 'pretailoring.page.singleBuildingBlockDataBlockDefinitionOfDone',
    defaultMessage: 'Definition of Done:',
    description: 'Pretailoring page single building block data block definition of done',
  },
  singleBuildingBlockDataBlockCompetencies: {
    id: 'pretailoring.page.singleBuildingBlockDataBlockCompetencies',
    defaultMessage: 'Competencies:',
    description: 'Pretailoring page single building block data block competencies',
  },
  questionFilterLabel: {
    id: 'pretailoring.page.questionFilterLabel',
    defaultMessage: 'Show:',
    description: 'Pretailoring page question filter label',
  },
  questionFilterPlaceholder: {
    id: 'pretailoring.page.questionFilterPlaceholder',
    defaultMessage: 'Select filter',
    description: 'Pretailoring page question filter placeholder',
  },
  questionFilterOptionAll: {
    id: 'pretailoring.page.questionFilterOptionAll',
    defaultMessage: 'All',
    description: 'Pretailoring page question filter option all',
  },
  questionFilterOptionAnswered: {
    id: 'pretailoring.page.questionFilterOptionAnswered',
    defaultMessage: 'Answered',
    description: 'Pretailoring page question filter option answered',
  },
  questionsFilterOptionUnanswered: {
    id: 'pretailoring.page.questionsFilterOptionUnanswered',
    defaultMessage: 'Unanswered',
    description: 'Pretailoring page questions filter option unanswered',
  },
  questionsNoQuestions: {
    id: 'pretailoring.page.questionsNoQuestions',
    defaultMessage: 'No questions found.',
    description: 'Pretailoring page questions no questions',
  },
  notAllQuestionsAnsweredModalTitle: {
    id: 'pretailoring.page.notAllQuestionsAnsweredModalTitle',
    defaultMessage: 'Not all questions answered',
    description: 'Pretailoring page not all questions answered modal title',
  },
  notAllQuestionsAnsweredModalText: {
    id: 'pretailoring.page.notAllQuestionsAnsweredModalText',
    defaultMessage: 'Some tailoring questions have not been answered. Are you sure you want to proceed?',
    description: 'Pretailoring page not all questions answered modal text',
  },

  openLink: {
    id: 'pretailoring.page.openLink',
    defaultMessage: 'Open link',
    description: 'Pretailoring page open link',
  },
});

export { pretailoringPageMessages };
